<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Pedido: Detalles</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Observación</th>
          <th scope="col">PedidoFechaReg</th>
          <th scope="col">ExamenNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pedidodet in datosPaginados" :key="pedidodet.idPedidoDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(pedidodet.idPedidoDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(pedidodet.idPedidoDet)" title="Editar">edit_square</i></td>
          <td>{{pedidodet.observacion}}</td>
          <td>{{getFormattedDate(pedidodet.pedidoFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{pedidodet.examenNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePedidoDet(pedidodet.idPedidoDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPedidoDet" class="form-label">IdPedidoDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPedidoDet" name="idPedidoDet" v-model="datoPedidoDet.idPedidoDet" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Pedido -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPedido" class="form-label"> Pedido</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPedido" name="idPedido" v-model="datoPedidoDet.idPedido">
                      <option v-for="pedido in pedidos" :value="pedido.idPedido" :key="pedido.idPedido">
                        {{ pedido.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Pedido -->
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoPedidoDet.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Examen -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idExamen" class="form-label"> Examen</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idExamen" name="idExamen" v-model="datoPedidoDet.idExamen">
                      <option v-for="examen in examens" :value="examen.idExamen" :key="examen.idExamen">
                        {{ examen.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Examen -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoPedidoDet.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPedidoDet" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPedidoDet" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      pedidodets : [],
      datoPedidoDet : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      pedidos: [],
      elementos: [],
      examens: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchPedidos()
    this.fetchElementos()
    this.fetchExamens()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.pedidodets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwpedidodets/nombre/'+this.nombreBusqueda).then(response=>{
          this.pedidodets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.pedidodets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwpedidodets').then(response=>{
      this.pedidodets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.pedidodets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPedido'
        ,'idElemento'
        ,'idExamen'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idPedido'
        ,'idElemento'
        ,'idExamen'
        ,'observacion'
      ];
      return validarForm(this.datoPedidoDet, requiredFields, requiredFieldsText);
    },
    async guardarPedidoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pedidodets', this.datoPedidoDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PedidoDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPedidoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pedidodets', this.datoPedidoDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PedidoDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPedidoDet={}
      this.titulo   = 'Crear Pedido: Detalles'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idPedidoDet){
      this.modalWindow = true
      if(idPedidoDet != null){    
           api.get('/vwpedidodets/'+idPedidoDet).then(resp=>{
          this.datoPedidoDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Pedido: Detalles'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idPedidoDet){
      if(idPedidoDet != null){
        this.$router.push('/pedidodetmd/'+idPedidoDet)
      }
    },
    async deletePedidoDet (idPedidoDet) {
      try{
        await api.delete('/pedidodets/'+idPedidoDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchPedidos() {
      fetch('http://localhost:8080/api/v1/pedidos')
        .then(response => response.json())
        .then(data => {
          this.pedidos = data;
        })
        .catch(error => {
          console.error('Error fetching pedidos:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchExamens() {
      fetch('http://localhost:8080/api/v1/examens')
        .then(response => response.json())
        .then(data => {
          this.examens = data;
        })
        .catch(error => {
          console.error('Error fetching examens:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
